import { createSaga } from './saga-helpers';

import * as Api from '../api/billing-api';

const watchGetBillingSources = createSaga({
    type: 'BILLING_SOURCES_FETCH',
    fn: Api.fetchSources
});

const watchCreateBillingSource = createSaga({
    type: 'BILLING_SOURCE_CREATE',
    fn: Api.createSource,
    args: action => [action.payload.stripeToken]
});

const watchRemoveBillingSource = createSaga({
    type: 'BILLING_SOURCE_REMOVE',
    fn: Api.removeSource,
    args: action => [action.payload.source]
});

const watchGetBillingHistory = createSaga({
    type: 'BILLING_HISTORY_FETCH',
    fn: Api.fetchHistory
});

const sagas = [watchGetBillingSources, watchCreateBillingSource, watchRemoveBillingSource, watchGetBillingHistory];

export default sagas;
